export default {
  SALESFORCE_CLIENT_ID_LABEL: 'Consumer Key',
  SALESFORCE_CLIENT_SECRET_LABEL: 'Consumer Secret',
  SALESFORCE_DEFINE_FILTER_COMPLETED: 'Setup Complete',
  SALESFORCE_DEFINE_FILTER_CONFIRM_CTA: 'Confirm Filters',
  SALESFORCE_DEFINE_FILTER_DESCRIPTION:
    'Use Filters to define which Salesforce records to import. Only records that meet the conditions set below will be considered for import.',
  SALESFORCE_DEFINE_FILTER_HEADER: 'Filtering Salesforce Data',
  SALESFORCE_DEFINE_FILTER_NO_RECORDS_MSG:
    'Error: No records found.  At least 1 constituent must be identified to complete setup.',
  SALESFORCE_DEFINE_FILTER_GENERAL_ERROR_MSG:
    'Error: Something went wrong. Please try again.',
  SALESFORCE_DEFINE_FILTER_EXIT_CTA: 'Exit Setup',
  SALESFORCE_DEFINE_FILTER_LEGEND: 'Filter Rule',
  SALESFORCE_DEFINE_FILTER_NEXT_CTA: 'Continue',
  SALESFORCE_DEFINE_FILTER_PROCESSING:
    'The system is processing the settings. This may take a few minutes. ',
  SALESFORCE_DEFINE_FILTER_PROCESSING_COMPLETED: 'Processing complete',
  SALESFORCE_REVIEW_DATA_DESCRIPTION:
    'The following is based on the defined rules and paramaters.',
  SALESFORCE_REVIEW_DATA_HEADER: 'Review Importing Data',
  SALESFORCE_REVIEW_DATA_SUBHEADER: 'Salesforce Filtered Account & Contacts',
  SALESFORCE_REVIEW_DATA_TOTAL_ACCOUNTS:
    '{total, plural, =1 {1 Account} other {# Accounts}}',
  SALESFORCE_REVIEW_DATA_TOTAL_CONTACTS:
    '{total, plural, =1 {1 Contact} other {# Contacts}}',
  SALESFORCE_REVIEW_DATA_TOTAL_HOUSEHOLDS:
    '{total, plural, =1 {1 Household} other {# Households}}',
  SALESFORCE_REVIEW_DATA_TOTAL_HOUSEHOLD_CONTACTS:
    '{total, plural, =1 {1 Household contact} other {# Household contacts}}',
  SALESFORCE_REVIEW_DATA_TOTAL_ORG_CONTACTS:
    '{total, plural, =1 {1 Organization contact} other {# Organization contacts}}',
  SALESFORCE_REVIEW_DATA_TOTAL_ORGS:
    '{total, plural, =1 {1 Organization} other {# Organizations}}',
  SALESFORCE_FILTER_OBJECT_TYPE_LABEL: 'Object Type',
  SALESFORCE_FILTER_FIELD_LABEL: 'Salesforce Field',
  SALESFORCE_FILTER_OPERATOR_LABEL: 'Operator',
  SALESFORCE_FILTER_OBJECT_TYPE_CONTACT: 'Contact',
  SALESFORCE_FILTER_OBJECT_TYPE_ACCOUNT: 'Account',
  SALESFORCE_FILTER_VALUE_LABEL: 'Salesforce Value',
  SALESFORCE_FILTER_VALIDATION_HELPER_TEXT:
    'Please fill out all required fields',
  SALESFORCE_IMPORT_STEPS_HEADER: 'Import Steps',
  SALESFORCE_IMPORT_STEPS_WARNING:
    "<strong>Warning: Importing of data can't be undone.</strong><br></br> If you have any questions, please contact the Instil team at <emailLink>support@instil.io</emailLink>.",
  SALESFORCE_ACCOUNTS_CONTACTS_SUBHEADER: 'Accounts & Contacts',
  SALESFORCE_ACCOUNTS_CONTACTS_DESCRIPTION:
    'Define the behavior for Salesforce Account and Contact objects within Instil.',
  SALESFORCE_ACCOUNTS_CONTACTS_CTA: 'Define Constituents',
  SALESFORCE_IMPORT_DATA_SUBHEADER: 'Import Salesforce Data',
  SALESFORCE_IMPORT_DATA_DESCRIPTION:
    'Once the import has begun it will take a few minutes. You will receive an email when the import has been completed.',
  SALESFORCE_IMPORT_DATA_CTA: 'Begin Import',
  SALESFORCE_REMOVE_FILTER_LABEL: 'Remove Filter',
  SALESFORCE_SUBMIT_EXIT: 'Exit',
};
